import { axios } from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAnalytics(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/dashboards', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
